var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"loading":_vm.carregando,"items":_vm.escolaridades,"item-text":"descricao","item-value":"codigo","no-data-text":"Nenhuma escolaridade encontrada"},model:{value:(_vm.escolaridadeModel),callback:function ($$v) {_vm.escolaridadeModel=$$v},expression:"escolaridadeModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }